import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaxValidatorDirective } from './max-validator.directive';
import { MinValidatorDirective } from './min-validator.directive';
import { MaxLengthValidatorDirective } from './maxlength-validator.directive';
import { MinLengthValidatorDirective } from './minlength-validator.directive';

const DIRECTIVES = [
    MaxValidatorDirective,
    MinValidatorDirective,
    MaxLengthValidatorDirective,
    MinLengthValidatorDirective,
];

/**
 * A collection of common non-business-related Directives that can be used throughout the entire app
 */
@NgModule({
    declarations: [
        DIRECTIVES,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        DIRECTIVES,
    ],
    providers: [],
})
export class GlobalDirectivesModule {
}
